import { ServerService, TcoService } from '@amzn/awscat-portfolio-assessment-service-client';
import { ServerBulkUpdateParams, Tenancy} from '@amzn/awscat-portfolio-assessment-types';
import { FlashContextInterface, FlashType, withFlashContext } from '@amzn/awscat-react-components';
import { Button } from '@amzn/awsui-components-react';
import { useContext } from 'react';

import { constants } from '../../../../common/Localization';
import { ErrorWithResponse } from '../../../../common/types';
import { TcoContext } from '../../../../contexts/TcoContext';
import { updateTCOAssessment } from '../../TCOHelper';

type Props = FlashContextInterface & {
    portfolioId: string;
    serverIds: string[];
};

const serverService = new ServerService();
const tcoService = new TcoService();
const TENANCY_FIELD_NAME = 'server.tenancy';

const DedicatedHostRemappingToSharedButton = ({ flash, portfolioId, serverIds }: Props): JSX.Element => {
    const {assessmentToUpdate, updateAssessment, updateTcoLoading} = useContext(TcoContext);

    const onApplyButtonClick = async () => {
        if (!portfolioId) {
            flash.alert(FlashType.error, constants.INVALID_PORTFOLIO_ID_ERROR, '');
            return;
        }
        try {
            updateTcoLoading(true);
            if (assessmentToUpdate) {
                const serverUpdateConditions: ServerBulkUpdateParams = {
                    fieldName: TENANCY_FIELD_NAME,
                    fieldValue: Tenancy.Shared,
                    portfolioId,
                    serverIds,
                };
                await serverService.update(serverUpdateConditions);
                const updatedAssessment = await updateTCOAssessment(portfolioId, assessmentToUpdate, tcoService);
                updateAssessment(updatedAssessment);
            }
        } catch (err) {
            flash.alert(
                FlashType.error, 
                (err as ErrorWithResponse).response?.data?.message ?? (err as Error).message, 
                constants.ERROR_UPDATING_ASSESSMENT);
        } finally {
            updateTcoLoading(false);
        }
    };

    return ( 
        <Button variant='link' onClick={onApplyButtonClick} data-testid='DHRemapBtn'>
            {constants.APPLY_BUTTON_TEXT}
        </Button>
    );
};

const DedicatedHostRemappingToSharedButtonWithFlash = withFlashContext(DedicatedHostRemappingToSharedButton);
export const generateDedicatedHostRemappingButton = (portfolioId: string, serverIds: string[]): JSX.Element => {
    return (
        <DedicatedHostRemappingToSharedButtonWithFlash
            portfolioId={portfolioId}
            serverIds={serverIds}
        />
    );
};
